module.exports = __webpack_public_path__ + "5945603abbf1b3525a5657aeb6d468d5.svg";